import apiClient from './apiClient';

export const profileService = {
  async getProfile() {
    const response = await apiClient.get('/profile');
    if (response && response.isSuccessful) {
      return response.content;
    }
    throw new Error(response?.message || 'Failed to retrieve profile');
  },

  async updateProfile(formData) {
    const response = await apiClient.put('/profile/student/profile', formData);
    if (response && response.isSuccessful) {
      return response.content;
    }
    throw new Error(response?.message || 'Failed to update profile');
  },

  async updateParentDetails(payload) {
    const response = await apiClient.put('/profile/student/parent-details', payload);
    if (response && response.isSuccessful) {
      return response.content;
    }
    throw new Error(response?.message || 'Failed to update parent details');
  }
};

export default profileService;
